var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stopBecauseInsecure)?_c('a',{attrs:{"href":_vm.registrationUrl(_vm.slug),"target":"_blank"}},[_vm._v("View order")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }